import * as React from 'react';
import { Input, InputPropsInterface, InputState } from './Input/Input';
import { InputInterface } from './Input/InputInterface';
import { NumberFormatter } from '../../Other/Format/NumberFormatter';
import { Format } from '../../Other/Format/Format';

// @ts-ignore
export interface NumberInputPropsInterface extends InputInterface<number> {
  decimals?: number;
  minimum?: number;
  maximum?: number;
  formatter?: NumberFormatter;
}

export class NumberInput extends React.Component<NumberInputPropsInterface, InputState<number>> {
  constructor(props: NumberInputPropsInterface) {
    super(props);

    this.userInput = this.renderValue(props.value);

    this.state = {
      value: props.value,
      stringValue: props.formatter.render(props.value),
      hasBlurred: true
    };
  }

  public componentWillReceiveProps(props: NumberInputPropsInterface) {
    if (this.state.hasBlurred) {
      this.setState({
        value: props.value,
        stringValue: props.formatter.render(props.value),
        hasBlurred: true
      });
    }
  }

  private userInput: string;

  public static defaultProps: NumberInputPropsInterface = {
    value: 0,
    className: ['Number'],
    automation: '',
    decimals: 0,
    formatter: new NumberFormatter(Format.fromLocale())
  };

  private readValue(value: string): number {
    if (!value) {
      value = '0';
    }

    if (value === '-') {
      value = '-0';
    }

    return parseFloat(value);
  }

  private getDefaultValue(): string {
    if (this.props.minimum > 0) {
      return '' + this.props.minimum;
    }

    return '0';
  }

  private isValid(value: number): boolean {
    const a = ('' + value).split('.');
    if (a.length > 1 && this.props.decimals < a[1].length) {
      return false;
    }

    if (this.props.minimum !== undefined && value < this.props.minimum) {
      return false;
    }

    if (this.props.maximum !== undefined && value > this.props.maximum) {
      return false;
    }

    return true;
  }

  private renderValue(value: number): string {
    const stringValue = '' + value;
    const a = stringValue.split('.');

    if (this.props.decimals < 1) {
      return a[0];
    }

    if (a.length < 2) {
      a.push('');
    }

    while (a[1].length < this.props.decimals) {
      a[1] = a[1] + '0';
    }

    return a.join('.');
  }

  private parse(stringValue: string): number {
    stringValue = stringValue.replace(' ', '');
    stringValue = stringValue.replace(',', '');
    stringValue = stringValue.replace(/[^0-9.]/g, '');
    const numberValue = parseFloat(stringValue);
    if (isNaN(numberValue)) {
      return 0;
    } else {
      return numberValue;
    }
  }

  public render(): JSX.Element {
    let value = this.getDefaultValue();
    if (this.props.onChange) {
      value = '' + this.props.value;
    } else {
      value = '' + this.state.stringValue;
    }

    // @ts-ignore
    const props: InputPropsInterface = {
      ...this.props,
      value: '' + value,
      onChange: (value: string, stringValue: string) => {
        const formatted = this.props.formatter.read(value);

        if (this.isValid(formatted)) {
          this.setState({
            ...this.state,
            value: formatted,
            stringValue
          });

          if (this.props.onChange) {
            this.props.onChange(this.props.formatter.read(value));
          }
        }
      },
      onBlur: (value: string) => {
        if (this.props.onBlur) {
          this.props.onBlur(this.state.value);
        }
      },
      className: ['Number']
    };

    return (
      <Input {...props}/>
    );
  }

}
